var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgQuote = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 75,
  height: 56,
  style: {
    isolation: "isolate"
  },
  viewBox: "0 0 75 56"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "_clipPath_Ez770RfwbK23SL6rmzZ53G2WBEabuwSR"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h75v56H0z"
})))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#_clipPath_Ez770RfwbK23SL6rmzZ53G2WBEabuwSR)"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#FDDF7D",
  fillRule: "evenodd",
  d: "M40.444 36.478C40.444 20.484 52.553 3.752 71.556 0l3.061 6.614C67.726 9.212 61.665 18.256 60.99 24.491c7.75 1.219 13.677 7.924 13.677 16.019 0 9.899-8.039 15.49-16.175 15.49-9.38 0-18.048-7.171-18.048-19.522M0 36.478C0 20.484 12.108 3.752 31.111 0l3.061 6.614c-6.891 2.598-12.951 11.642-13.626 17.877 7.75 1.219 13.676 7.924 13.676 16.019 0 9.899-8.039 15.49-16.174 15.49C8.668 56 0 48.829 0 36.478"
})))))));
export default SvgQuote;